// Reads a meta-tag content value, ensuring a trailing slash. Falls back to
// `fallback` when the tag is missing or still holds an un-substituted
// `__PLACEHOLDER__` marker (which happens if the host did not rewrite the
// shell - typically in tests or when serving the static file directly).
export const readBaseMeta = (name: string, fallback: string) => {
  const meta = document.head.querySelector(`meta[name=${name}]`);
  const raw = meta?.getAttribute("content")?.trim() ?? "";
  const value = !raw || raw.startsWith("__") ? fallback : raw;
  return value.endsWith("/") ? value : `${value}/`;
};

// Base path the SPA is served from. In development that is "/"; under IIS it
// may be "/my-application/". Mirrors HttpRequest.RelativeBasePath on the host.
export const baseUrl = readBaseMeta("baseUrl", "/");

// Absolute base URL including scheme/host (e.g. "https://example.com/my-app/").
// Mirrors HttpRequest.AbsoluteBasePath on the host. Falls back to a value
// derived from the current document when the host did not provide one.
export const absoluteBaseUrl = readBaseMeta(
  "absoluteBaseUrl",
  `${window.location.origin}${baseUrl}`
);
